import type { SearchFiltersValue } from '@openx/types/searchFiltersValue';

export function isSearchFiltersValue(filters: unknown): filters is SearchFiltersValue {
  if (typeof filters !== 'object' || !filters) {
    return false;
  }

  const filterKeys = Object.keys(filters);
  if (!['fields', 'phrase'].every(key => filterKeys.includes(key))) {
    return false;
  }

  const phrase = (filters as { phrase?: unknown }).phrase;
  if (phrase && typeof phrase !== 'string') {
    return false;
  }

  const fields = (filters as { fields?: unknown }).fields;
  return !fields || (Array.isArray(fields) && fields.every(field => typeof field === 'string'));
}
